<div class="submitted" role="status">
  <span class="submitted__icon" aria-hidden="true">
    <app-icon name="check-circle" [size]="32" />
  </span>
  <h2 class="submitted__title">Submitted — CapX is reviewing</h2>
  <p class="submitted__body">
    @if (dfIntent()) {
      Our team is reviewing what you've shared and will come back with your funding options for both
      Kickstart Cash and Debtors Finance.
    } @else {
      Our team is reviewing what you've shared and will come back with your funding options.
    }
  </p>

  <!-- Application status — one row per product, describing the one enquiry. -->
  <section class="status-card" aria-label="Application status" data-testid="submitted-status-card">
    <h3 class="status-card__title">Application status</h3>
    <dl class="status-card__rows">
      <div class="status-card__row" data-testid="submitted-status-ks">
        <dt>Kickstart Cash</dt>
        <dd><app-status-chip status="KS_UNDER_REVIEW" /></dd>
      </div>
      <div class="status-card__row" data-testid="submitted-status-df">
        <dt>Debtors Finance</dt>
        <dd><app-status-chip [status]="dfStatus()" /></dd>
      </div>
    </dl>
  </section>

  <ul class="submitted__facts">
    <li>
      <app-icon name="file-text" [size]="16" />
      <span>
        @if (documentCount() > 0) {
          {{ documentCount() }} {{ documentCount() === 1 ? 'document' : 'documents' }} shared
        } @else {
          No documents shared — we may ask for some to complete the review
        }
      </span>
    </li>
    <li>
      <app-icon name="clock" [size]="16" />
      <span>We review within one business day</span>
    </li>
  </ul>

  <!-- One next action. -->
  @switch (nextAction()) {
    @case ('while-you-wait') {
      <section class="next-action" aria-label="While you wait" data-testid="submitted-next-df">
        <h3 class="next-action__title">While you wait</h3>
        <p class="next-action__body">
          We'll review your Debtors Finance interest together with your enquiry and come back with
          both options — there's nothing more to do for now.
        </p>
      </section>
    }
    @case ('unlock-more') {
      <section
        class="next-action"
        aria-label="Unlock more funding"
        data-testid="submitted-next-unlock"
      >
        <h3 class="next-action__title">Unlock more funding</h3>
        <p class="next-action__body">
          Financial statements and a debtors age analysis can open up more options, including
          Debtors Finance. You can add them now — they'll be included in the review that's already
          under way.
        </p>
        <button
          mat-stroked-button
          type="button"
          (click)="addDocuments.emit()"
          data-testid="submitted-add-financials"
        >
          <app-icon name="plus" [size]="18" />
          <span>Add financial information</span>
        </button>
      </section>
    }
  }

  <p class="submitted__hint">
    You can track progress from your dashboard, and add documents to this enquiry at any time while
    it's under review.
  </p>
  <div class="submitted__actions">
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="dashboard.emit()"
      data-testid="submitted-dashboard-btn"
    >
      Back to dashboard
    </button>
    @if (nextAction() !== 'unlock-more') {
      <button
        mat-stroked-button
        type="button"
        (click)="addDocuments.emit()"
        data-testid="submitted-add-documents"
      >
        Add documents
      </button>
    }
  </div>
</div>
